import { render, staticRenderFns } from "./ApproveMobileHeader.vue?vue&type=template&id=32687bae"
import script from "./ApproveMobileHeader.vue?vue&type=script&lang=js"
export * from "./ApproveMobileHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports